<kabas-legals-hero></kabas-legals-hero>

<div class="[ container p-be-3xl stack ]">
  @if (slug$ | async; as slug) {
    @if (slug === 'privacy') {
      <kabas-legals-page-privacy></kabas-legals-page-privacy>
    }
    @if (slug === 'verkoopsvoorwaarden') {
      <kabas-legals-page-sales-conditions></kabas-legals-page-sales-conditions>
    }
    @if (slug === 'gebruiksvoorwaarden') {
      <kabas-legals-page-terms-of-use></kabas-legals-page-terms-of-use>
    }
    @if (slug === 'ai') {
      <kabas-legals-page-ai></kabas-legals-page-ai>
    }
  }
</div>
